import { post } from './http';

const makeUploader = accept => resolve => {
    const input = document.createElement('input');

    input.type = 'file';
    input.accept = accept;

    input.onchange = async e => {
        if (e.target['files'][0]) {
            const body = { file: e.target['files'][0], isPublic: true };

            const rs = await post('profile', 'file/upload', body);
            if (rs == null){
                resolve (null);
            }

            resolve(rs);
        } else {
            resolve(null);
        }
    };

    input.click();
};

const imageUploadExecutor = makeUploader('.jpg, .jpeg, .png');

const allUploadExecutor = makeUploader('*');

const getUrlExecutor = (url, stubUrl) => (resolve) => {
    const img = new Image();
    const bg = url;
    const ph = stubUrl;

    const cb1 = () => {
        resolve(bg);
    };
    const cb2 = () => {
        resolve(ph);
    };
    img.onload = cb1;
    img.onerror = cb2;

    img.src = url;
};

export const imageUploader = () => new Promise(imageUploadExecutor);

export const avatarBinder = async (config, avatarType) => {
    return await post('profile', `user/avatar/bind/${avatarType}`, config, true);
};

export const allUploader = () => new Promise(allUploadExecutor);

export const getImgUrl = (url, stubUrl) =>
    new Promise(getUrlExecutor(url, stubUrl));
